"use client";

import { useState } from "react";

interface Props {
  title: string;
  excerpt: string | null;
}

export default function ShareRow({ title, excerpt }: Props) {
  const [copied, setCopied] = useState(false);

  async function copyLink() {
    try {
      const url =
        typeof window !== "undefined" ? window.location.href : "";
      await navigator.clipboard.writeText(url);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1800);
    } catch {
      // ignore — older browsers without clipboard API
    }
  }

  const mailHref = (() => {
    const url = typeof window !== "undefined" ? window.location.href : "";
    const subject = encodeURIComponent(title);
    const body = encodeURIComponent(
      `${excerpt ? excerpt + "\n\n" : ""}${url}`,
    );
    return `mailto:?subject=${subject}&body=${body}`;
  })();

  const baseBtn =
    "inline-flex items-center gap-2 text-[13px] text-[#002e65] hover:text-[#0055a4] transition-colors";

  return (
    <div>
      <div className="text-[11px] tracking-[0.22em] uppercase text-[#002e65]/55 font-semibold mb-2">
        Share
      </div>
      <div className="flex flex-col gap-2">
        <button type="button" onClick={copyLink} className={baseBtn}>
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden
          >
            <path d="M10 13a5 5 0 0 0 7.07 0l3-3a5 5 0 0 0-7.07-7.07L11 5" />
            <path d="M14 11a5 5 0 0 0-7.07 0l-3 3a5 5 0 0 0 7.07 7.07L13 19" />
          </svg>
          <span>{copied ? "Link copied" : "Copy link"}</span>
        </button>
        <a href={mailHref} className={baseBtn}>
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden
          >
            <rect x="3" y="5" width="18" height="14" rx="2" />
            <polyline points="3 7 12 13 21 7" />
          </svg>
          <span>Email</span>
        </a>
      </div>
    </div>
  );
}
